module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page activity-page px-5"
  }, [(_vm.isPageReady && !_vm.isComp) ? _c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('label', [_vm._v("Activity")])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(!_vm.activities || _vm.activities.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("No Activity")]), _vm._v(" "), _c('p', {
    staticClass: "empty-description"
  }, [_vm._v("\n        This is where you'll see who followed, commented, and other\n        activity.\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/album"
    }
  }, [_vm._v("Discover")])], 1) : _c('div', {
    staticClass: "activity-item-wrapper"
  }, [_c('div', {
    staticClass: "activity-item-parent"
  }, [(
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('div', {
    staticClass: "invite-header"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "round-avatar __logo",
    style: ({
      'background-image': 'url(' + _vm.youLogo + ')'
    }),
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "__text"
  }, [_vm._v("Invite your friends!")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-pill",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.show_invite_dialog = true
      }
    }
  }, [_vm._v("Invite")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.activities.slice(0, 100)), function(activity, index) {
    return _c('activity-item', {
      key: index,
      attrs: {
        "activityItem": activity
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "suggested-users"
  }, [_c('h2', {
    staticClass: "mb-3"
  }, [_vm._v("Suggested people to follow")]), _vm._v(" "), _vm._l((5), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "suggested-user"
    }, [_c('div', {
      staticClass: "dflex justify-space-between align-center"
    }, [_c('user-tag', {
      attrs: {
        "user": _vm.currentUser,
        "showAvatar": "",
        "width": "70",
        "height": "70",
        "marginRight": "20"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "follow-btn",
      attrs: {
        "depressed": "",
        "round": "",
        "dark": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.followUser(user)
        }
      }
    }, [_vm._v("\n              Follow\n            ")])], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_dialog),
      callback: function($$v) {
        _vm.show_invite_dialog = $$v
      },
      expression: "show_invite_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Invite Artist/Brand")]), _vm._v(" "), _c('v-card-text', [_vm._v("Link expires in 72 hours and can only be used once")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createInvitation()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("fa-link")]), _vm._v(" Copy Link")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.link_copied),
      expression: "link_copied"
    }],
    staticClass: "link-copied"
  }, [_vm._v("link has been copied")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5cf286","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/activity/index.vue
// module id = 1736
// module chunks = 180